import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MessageService } from "primeng/api";

import { SessionService } from "../../common/services/session.service";
import { OfficeService } from "../../office/officeService/api/office.service";
import { ApiService } from "../../service/api/api.service";
import { UserInterface } from "../user.interface";
import { UserService } from "../userService/api/user.service";

@Component({
  selector: 'app-permission-mgmt-create',
  templateUrl: './permission-mgmt-create.component.html',
  styleUrls: ['./permission-mgmt-create.component.scss'],
  providers: [MessageService],
})
export class PermissionMgmtCreateComponent implements OnInit {
  userObj: UserInterface;
  roles: Array<any>;
  userInfo: any;
  selectedRole: any;
  userId: string;
  editableMode: boolean = false;

  index: number = 0;
  stepOneFlag: boolean = false;

  district: any;
  states: any;

  constructor(
    private toast: MessageService,
    private apiService: ApiService,
    private userService: UserService,
    private sessionService: SessionService,
    private officeService: OfficeService,
    private router: Router,
    private actRoute: ActivatedRoute
  ) {
    this.userObj = {};
    this.userObj.status = true;
    this.userObj.password = "12345";
  }

  // getState() {
  //   this.apiService.getStateData().subscribe((data) => {
  //     this.states = data;
  //   });
  // }

  // stateForDist() {
  //   let selectedState = this.userObj.states['id'];
  //   this.getDist(selectedState);
  // }

  // getDist(selectedState) {
  //   this.states.forEach(element => {
  //     if (element.id == selectedState) {
  //       this.district = element.districts;
  //     }
  //   });
  // }

  getEditData() {
    this.editableMode = true;
    this.userService.getUserEdit(this.userId).subscribe((userData) => {
      this.setData(userData);
    });
  }
  setData(userData) {
    this.userObj = {
      id: userData.id,
      name: userData.name,
      email: userData.email,
      phone: userData.phone,
      role: userData.role,
      password: userData.password,
      aadhar: userData.aadhar,
      status: userData.status,
      // 'address': userData.address,
      // 'city': userData.city,
      // 'pincode': userData.pincode,
      // 'states': userData.states,
      // 'district': userData.district,
      // 'office': userData.office
    };
    // this.getState();
    this.getRole();
    this.roles.filter((ele) => {
      ele.name === userData.role ? (this.selectedRole = ele) : "";
    });
  }

  getRole() {
    this.roles = [
      { name: "SUPER_ADMIN", value: "01" },
      { name: "VIEWER", value: "02" },
    ];
  }

  saveUser(userData) {
    if (!userData.valid) {
    } else {
      this.userObj.role = this.selectedRole["name"];
      if (this.editableMode) {
        this.userService.updateUser(this.userObj).subscribe((res) => {
          this.toast.add({
            severity: "success",
            summary: "Updated Successfully",
            detail: "User Update Successfully !!!",
          });
          this.router.navigate(["/user/list"]);
        });
      } else {
        this.userService.createUserData(this.userObj).subscribe((res) => {
          this.router.navigate(["/user/list"]);
        });
      }
    }
  }

  ngOnInit() {
    this.userId = this.actRoute.snapshot.paramMap.get("id");

    this.userInfo = this.sessionService.getUserInfo();

    setTimeout(() => {
      if (this.userId === null) {
        // this.getState();
        this.getRole();
      } else {
        this.getEditData();
      }
    });
  }
}
